<template>
  <div class="getFrame">
    <main class="t-main">
      <ol class="m-breadcrumb">
        <li class="m-breadcrumb__item"><router-link class="a-text a-link" to="/delivery/list-frame">枠一覧</router-link></li>
        <li class="m-breadcrumb__item"><span class="a-text">枠詳細</span></li>
      </ol>
      <h1 class="a-title">{{ getFrameTitle }}</h1>
      <div class="m-form__item-wrapper">
        <h2 class="a-title a-title--sub m-form__item--30">タイトル</h2>
        <a class="a-title a-title--sub a-text">{{tasks.metadata.name}}</a>
      </div>
      <br/><hr/><br/>
      <div class="m-form__item-wrapper">
        <h2 class="a-title a-title--sub m-form__item--30">表示（非表示）ページ</h2>
        <label class="m-form__label">正規表現で設定
          <ul><li v-for="list in tasks.configuration.pages" class="a-text"><a class="a-title a-title--sub a-text">{{list.pattern}}</a> : <a class="a-title a-title--sub a-text">{{pageMode[list.mode]}}</a></li></ul>
        </label>
      </div>
      <br/><hr/><br/>
      <div class="m-form__item-wrapper">
        <h2 class="a-title a-title--sub m-form__item--30">セグメント</h2>
        <a v-if="tasks.configuration.segments.length==1" class="a-title a-title--sub a-text">{{tasks.configuration.segments[0].segmentId}}</a>
      </div>
      <br/><hr/><br/>
      <div class="m-form__item-wrapper">
        <h2 class="a-title a-title--sub m-form__item--30">アクション種別</h2>
        <a class="a-title a-title--sub a-text">{{actionType}}</a>
      </div>
      <br/><hr/><br/>
      <div class="m-form__item-wrapper">
        <h2 class="a-title a-title--sub m-form__item--30">アクション設定</h2>
        <label class="m-form__label">
          <ul><li v-for="list in tasks.configuration.actions" class="a-text"><a class="a-title a-title--sub a-text">{{actionNames[list.actionId]}}</a>　　出現率：<a class="a-title a-title--sub a-text">{{list.ratio}}％</a></li></ul>
        </label>
      </div>
      <br/><hr/><br/>

      <div class="m-form__item-wrapper">
        <h2 class="a-title a-title--sub m-form__item--30">ルール</h2>
        <label class="m-form__label">
          <ul>
            <li v-for="list in tasks.configuration.rules" class="a-text">
              <div class="m-form__item-wrapper">
                <h2 class="a-title a-title--sub m-form__item--40" >{{ruleList[list.type]}}</h2>
                <div class="m-form__item-wrapper m-form__item--60">
                  <div class="m-form__item" v-for="(val, key) in list">
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && (key=='count' || key=='threashold' || key=='seconds'|| key=='interval')"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && key=='operator' && (list.type=='visit-count' || list.type=='last-page-view' || list.type=='page-view-count' || list.type=='stay-seconds' || list.type=='view-page-path')"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{jpList[list[key]]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && key=='operator' && list.type!='visit-count' && list.type!='last-page-view' && list.type!='page-view-count' && list.type!='stay-seconds' && list.type!='view-page-path'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{jpList[list[key]]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && key=='scope'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{jpList[list[key]]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='referer' && key=='page'"
                    >リファラ（ドメイン）
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='user-os' && key=='value'"
                    >OS名
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='frequency' && key=='periodType'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{jpList[list[key]]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='frequency' && key=='dayOfWeekThreshold' && list.periodType == 'week'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{jpList[list[key]]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='frequency' && key=='minuteThreshold'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='frequency' && key=='dayThreshold' && list.periodType == 'month'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type=='frequency' && key=='hourThreshold' && (list.periodType == 'day' || list.periodType == 'month' || list.periodType == 'week')"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && list.type!='referer' && list.type!='user-os' && (key=='page' || key=='page1' || key=='page2' || key=='page3' || key=='value' || key=='values' || key=='link')"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label class="m-form__label m-form__item--100" v-if="key=='timezone'">{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && (key=='start' || key=='end') && list.type!='day-period'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                    <label
                     class="m-form__label m-form__item--100"
                     v-if="key!='type' && (key=='start' || key=='end') && list.type=='day-period'"
                    >{{jpList[key]}}
                      <p><a class="a-text">{{list[key]}}</a></p>
                    </label>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </label>
      </div>
      <br/><hr/><br/>
      <p class="a-button__wrapper">
        <button class="a-button" v-on:click="goupdateframe">枠編集画面へ</button>
        <button class="a-button a-button--cansel" v-on:click="golistframe">戻る</button>
      </p>
    </main>
  </div>
</template>

<script>
import store from '../../../stores'
import { pageMode, ruleList, operatorList, strOperatorList, jpList, scopeList, weekList, rulememoList, timezoneList } from '../../../constants'

export default {
  name: 'getFrame',
  data() {
    return {
      getFrameTitle: '枠詳細',
      pageMode,
      ruleList,
      rulememoList,
      operatorList,
      strOperatorList,
      jpList,
      scopeList,
      weekList,
      timezoneList,
      addRule: '',
      addAction: ''
    }
  },
  created() {
    store.dispatch('checkSessionId')
    store.dispatch('getFrameData', { fqdn: this.$route.query.fqdn, frameId: this.$route.query.frameId })
  },

  computed: {
    tasks: { get() { return store.state.frame.frame } },
    actionType: { get() { return store.state.frame.actionType } },
    actionNames: {
      get() {
        let actionNames = {}
        let actionList = store.state.frame.actionList
        for (let i = 0; i < actionList.length; i++) {
          actionNames[actionList[i].actionId] = actionList[i].metadata.name
        }
        return actionNames
      }
    }
  },

  methods: {
    callframe: function() { store.dispatch('frame', this.tasks) },
    goupdateframe: function() {
      this.$router.push('/delivery/update-frame?frameId=' + this.$route.query.frameId + '&fqdn=' + this.$route.query.fqdn)
    },
    golistframe: function() {
      this.$router.push('/delivery/list-frame')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/frame/GetFrame.vue